import React, { useId, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import L from 'leaflet'
import { Marker } from 'react-leaflet'
import './enhanced-marker-styles.scss'

type Props = {
  eventHandlers?: {
    add?: (...args: any[]) => void;
    remove?: (...args: any[]) => void;
  };
  icon: React.ReactNode;
} & Omit<React.ComponentProps<typeof Marker>, 'icon'>;

const EhancedMarker: React.FC<Props> = ({
  eventHandlers,
  icon: providedIcon,
  ...otherProps
}) => {
  const [markerRendered, setMarkerRendered] = useState(false)
  const id = "marker-" + useId()

  const icon = useMemo(
    () =>
      L.divIcon({
        html: `<div id="${id}"></div>`,
      }),
    [id]
  )

  return (
    <>
      <Marker
        {...otherProps}
        eventHandlers={{
          ...eventHandlers,
          add: (...args: any) => {
            setMarkerRendered(true);
            if (eventHandlers?.add) eventHandlers.add(...args);
          },
          remove: (...args: any) => {
            setMarkerRendered(false);
            if (eventHandlers?.remove) eventHandlers.remove(...args);
          },
        }}
        icon={icon}
      />
      {markerRendered &&
        createPortal(providedIcon, document.getElementById(id) as Element | DocumentFragment)}
    </>
  )
}

export default EhancedMarker
